import { ReturnDocument } from '@/domain/returns'
import { Modal } from '@itsrever/design-system'
import { useState } from 'react'

interface DocumentProps {
  doc: ReturnDocument
  index: number
}

export const Document: React.FC<DocumentProps> = ({ doc, index }) => {
  const [imageModalOpen, setImageModalOpen] = useState(false)

  const handleClickDoc = () => {
    setImageModalOpen(true)
  }
  const requestClose = () => {
    setImageModalOpen(false)
  }

  const info = doc.information ? doc.information : `Doc. ${index + 1}`
  return (
    <>
      <div
        className="flex h-fit w-[200px] cursor-pointer flex-col overflow-hidden rounded-lg border border-solid border-[#ccc] bg-white shadow-sm"
        onClick={handleClickDoc}
      >
        <div
          className="h-40 w-full rounded rounded-b-md bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${doc.url})`
          }}
        />

        <div className="flex grow flex-col justify-between p-2">
          <div className="flex flex-col justify-center">
            <p className="mb-1 truncate px-4 text-center text-sm">{info}</p>
          </div>
        </div>
      </div>
      <Modal isOpen={imageModalOpen} onRequestClose={requestClose} showBackdrop>
        <p className="mb-6 mt-3 font-light">{info}</p>
        <img
          src={doc.url}
          alt={info}
          className=" max-h-[800px] max-w-[800px] rounded"
        />
      </Modal>
    </>
  )
}
